import { User } from "@drl/core/auth/models/user.model";

export class DashboardMsgDateDto {
  dayWise: {
    [Key: string]: {
      openMsgCount: number;
      totalMsgCount: number;
    };
  };
  totalCount: number;
}


export class PatientUnreadMessageSummaryDto {
  patientId: number;
  unreadCount: number;
  latestSubject: string;
  latestBody: string;
  latestCreatedOn: string; // ISO date string
  sentBy: number;
  sentCount: number;
  sender: User;
  timeElapsed: string;

  constructor(data: Partial<PatientUnreadMessageSummaryDto>) {
    Object.assign(this, data);
  }
}

export class ChatDashboardCountDto {
  unreadCount: number=0;  
  constructor(data?: Partial<ChatDashboardCountDto>) {
    Object.assign(this, data);
  }
}